import React from 'react';
import OrganSystemCircle from '../OrganSystemCircle/OrganSystemCircle';
import HelixLoader from '../HelixLoader/HelixLoader';
import './OrganSystemDashboard.css';

/**
 * Dashboard showing all organ system health scores
 */
function OrganSystemDashboard({
  systemScoresArray,
  selectedSystem,
  onSystemClick,
  isLoading,
  highlightedSystems = [],
  previousScores = {},
  focusedSystem = null,
  onTestPillClick,
  onTimelineClick,
  onMoreInfoClick,
  onProtocolClick,
  onUploadClick,
  onManualEntry,
  bloodTestFiles,
  getFxRange,
  sex,
  selectedFileIndex,
  loadingFiles
}) {
  if (isLoading || loadingFiles) {
    return (
      <div className="organSystemDashboard loading">
        <HelixLoader dotCount={15} gap={2} />
      </div>
    );
  }

  if (!systemScoresArray || systemScoresArray.length === 0) {
    return (
      <div className="organSystemDashboard empty">
        <div className="emptyText">Upload blood tests to see system health scores</div>
        <div className="osd-empty-actions">
          {onUploadClick && (
            <button className="osd-upload-btn" onClick={onUploadClick}>
              Upload Test
            </button>
          )}
          {onManualEntry && (
            <button className="osd-upload-btn" onClick={onManualEntry}>
              Manual Entry
            </button>
          )}
        </div>
      </div>
    );
  }

  const closeFocus = () => {
    if (focusedSystem) onSystemClick(focusedSystem);
  };

  return (
    <div className="organSystemDashboard">
      <div className="systemsGrid">
        {systemScoresArray.map(system => {
          const isBlurred = focusedSystem != null && focusedSystem !== system.id;
          return (
            <OrganSystemCircle
              key={system.id}
              systemId={system.id}
              displayName={system.displayName}
              icon={system.icon}
              score={system.score}
              confidence={system.confidence}
              color={system.color}
              selected={selectedSystem === system.id}
              highlighted={highlightedSystems.includes(system.id)}
              focused={focusedSystem === system.id}
              blurred={isBlurred}
              onTestPillClick={onTestPillClick}
              onClick={() => isBlurred ? closeFocus() : onSystemClick(system.id)}
              previousScore={previousScores[system.id]}
              onTimelineClick={onTimelineClick ? () => onTimelineClick(system.id) : undefined}
              onMoreInfoClick={onMoreInfoClick}
              onProtocolClick={onProtocolClick}
              bloodTestFiles={bloodTestFiles}
              getFxRange={getFxRange}
              sex={sex}
              selectedFileIndex={selectedFileIndex}
            />
          );
        })}
      </div>
    </div>
  );
}

export default OrganSystemDashboard;
